//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    sidebar: { type: Boolean, default: false }
  },
  methods: {
    logOut () {
      this.$store.commit('protect/LOGOUT')
      this.$router.push('/protect/auth')
    }
  }
}
